export enum BrandContentType {
  NoEmailAddress = 'NOEMAILADDRESS',
  OptionDisclaimer = 'OPTIONDISCLAIMER',
  EmailReplyToAndFromAddress = 'EMAILREPLYTOANDFROM',
  ResidentDefinitionUrl = 'RSPORTALURL',
  EmailFooter = 'EFOOTER',
  TermsAndConditionsHeader = 'TNCHEADER',
  EmailPolicyDocuments = 'EMAILDOC',
  MembershipLabel = 'EXTERNALMEMBERSHIPNUMBERLABEL',
  MembershipHeading = 'EXTERNALMEMBERSHIPNUMBERHEADING',
  MembershipSubHeading = 'EXTERNALMEMBERSHIPNUMBERSUBHEADING',
}
